import { includesText } from "utils/string-utils";
import { ShapeLibrary, ShapeItem, ShapeGroup, FilteredShapeLibrary, FilteredShapeGroup } from "./types";

export function filterGroup(group: ShapeGroup, searchTerm: string): FilteredShapeGroup | null {
  if (includesText(group.displayName, searchTerm)) {
    return group;
  }
  const filteredItems = group.items.filter((item: ShapeItem) => includesText(item.displayName, searchTerm));
  return filteredItems.length > 0 ? { ...group, items: filteredItems } : null;
}

export function filterLibrary(library: ShapeLibrary, searchTerm: string): FilteredShapeLibrary | null {
  if (includesText(library.displayName, searchTerm) || includesText(library.id, searchTerm)) {
    return library;
  }
  const filteredGroups = library.groups.map((group: ShapeGroup) => filterGroup(group, searchTerm)).filter(Boolean);
  return filteredGroups.length > 0 ? { ...library, groups: filteredGroups } : null;
}
